export enum CROP_ACTION {
  GAP_ACTION = 'gap_action',
  NUTRITION_MANAGEMENT = 'nutrition_management',
  WATER_MANAGEMENT = 'water_management',
  CROP_PROBLEM = 'crop_problem',
}

export enum ACTION_TAG {
  PAST = 'Past',
  CURRENT = 'Current',
  UPCOMING = 'Upcoming',
}
